import { Button } from '@material-ui/core';
import React, { useState, useRef, useEffect } from 'react';

interface Props {
  html: string;
  maxLines?: number;
}

export default function HtmlClamp({ html, maxLines = 2 }: Props) {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const fullHeight = el.scrollHeight;

    el.style.webkitLineClamp = String(maxLines);
    el.style.display = '-webkit-box';
    el.style.webkitBoxOrient = 'vertical';
    el.style.overflow = 'hidden';

    setTimeout(() => {
      const clampedHeight = el.scrollHeight;

      if (fullHeight > clampedHeight) {
        setIsClamped(true);
      }
    }, 50);
  }, [html, maxLines]);

  return (
    <div>
      <div
        ref={contentRef}
        style={{
          display: expanded ? 'block' : '-webkit-box',
          WebkitLineClamp: expanded ? 'unset' : maxLines,
          WebkitBoxOrient: 'vertical',
          overflow: expanded ? 'visible' : 'hidden',
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />

      {isClamped && (
        <Button
          onClick={() => setExpanded((prev) => !prev)}
          style={{
            color: '#1976d2',
            cursor: 'pointer',
            marginTop: '4px',
            background: 'none',
            border: 'none',
            padding: 0,
            fontSize: '14px',
          }}
        >
          {expanded ? 'Ver menos' : 'Ver mais'}
        </Button>
      )}
    </div>
  );
}
